module.exports={select:"Selecteren",selected:"Geselecteerd"};